import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

import { addQueryParam } from 'utils/urlutils';
import get from 'lodash/get';

export const GET_WISHLIST_DETAILS_REQUEST = 'GET_WISHLIST_DETAILS_REQUEST';
export const GET_WISHLIST_DETAILS_SUCCESS = 'GET_WISHLIST_DETAILS_SUCCESS';
export const GET_WISHLIST_DETAILS_ERROR = 'GET_WISHLIST_DETAILS_ERROR';

export const ADD_WISHLIST_ITEM_REQUEST = 'ADD_WISHLIST_ITEM_REQUEST';
export const ADD_WISHLIST_ITEM_SUCCESS = 'ADD_WISHLIST_ITEM_SUCCESS';
export const ADD_WISHLIST_ITEM_ERROR = 'ADD_WISHLIST_ITEM_ERROR';

export const REMOVE_WISHLIST_ITEM_REQUEST = 'REMOVE_WISHLIST_ITEM_REQUEST';
export const REMOVE_WISHLIST_ITEM_SUCCESS = 'REMOVE_WISHLIST_ITEM_SUCCESS';
export const REMOVE_WISHLIST_ITEM_ERROR = 'REMOVE_WISHLIST_ITEM_ERROR';

export function getWishlistDetailsAction() {
	return { type: GET_WISHLIST_DETAILS_REQUEST };
}

export function getWishlistDetailsSuccessAction(data) {
	return { type: GET_WISHLIST_DETAILS_SUCCESS, data };
}

export function getWishlistDetailsErrorAction(error) {
	return { type: GET_WISHLIST_DETAILS_ERROR, error };
}

export function fetchWishlistDetailsAction() {
	return dispatch => {
		dispatch(getWishlistDetailsAction());

		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/2/ugc/wishlist?count=-1'
			})
		).then(
			json => dispatch(getWishlistDetailsSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(getWishlistDetailsErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

export function addItemInWishlistAction() {
	return { type: ADD_WISHLIST_ITEM_REQUEST };
}

export function addItemInWishlistSuccessAction(data) {
	return { type: ADD_WISHLIST_ITEM_SUCCESS, data };
}

export function addItemInWishlistErrorAction(error) {
	return { type: ADD_WISHLIST_ITEM_ERROR, error };
}

export function addItemToWishlistAction(options) {
	return dispatch => {
		dispatch(addItemInWishlistAction());

		let pathname = '/api/2/ugc/wishlist/add';
		pathname = addQueryParam('productIds', options.productIds, pathname);
		pathname = addQueryParam('listingIds', options.listingIds, pathname);
		pathname = addQueryParam('tags', options.tags, pathname);

		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname
			})
		).then(
			json => {
				const { isSuccess, errorMessage } = get(json['RESPONSE'], 'wishlist');
				if (isSuccess === true) {
					return dispatch(addItemInWishlistSuccessAction(json['RESPONSE']));
				} else {
					dispatch(addItemInWishlistErrorAction(errorMessage));
					return Promise.reject(json['RESPONSE']);
				}
			},
			err => {
				dispatch(addItemInWishlistErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

export function removeItemInWishlistAction() {
	return { type: REMOVE_WISHLIST_ITEM_REQUEST };
}

export function removeItemInWishlistSuccessAction(data) {
	return { type: REMOVE_WISHLIST_ITEM_SUCCESS, data };
}

export function removeItemInWishlistErrorAction(error) {
	return { type: REMOVE_WISHLIST_ITEM_ERROR, error };
}

export function removeItemFromWishlistAction(options) {
	return dispatch => {
		dispatch(removeItemInWishlistAction());

		let pathname = '/api/2/ugc/wishlist/delete';
		pathname = addQueryParam('productIds', options.productIds, pathname);
		pathname = addQueryParam('listingIds', options.listingIds, pathname);
		pathname = addQueryParam('tags', options.tags, pathname);

		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname
			})
		).then(
			json => dispatch(removeItemInWishlistSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(removeItemInWishlistErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}
